export enum ProductionOrderStatesEnum {
    FINISHED = 'Finished',
    PAUSED = 'Paused',
    IN_PROGRESS = 'In progress',
    INACTIVE = 'Inactive',
    PENDING = 'Pending',
    CANCELLED = 'Cancelled',
    AWAITING = 'Awaiting'
}
